// extracted by mini-css-extract-plugin
export default {"variableIconWrapper":"WhiteLabeling_variableIconWrapper__sS7Nq","footerAlign":"WhiteLabeling_footerAlign__c8qKU"};